import { render, staticRenderFns } from "./JournalEditor.vue?vue&type=template&id=56158353&scoped=true&"
import script from "./JournalEditor.vue?vue&type=script&lang=js&"
export * from "./JournalEditor.vue?vue&type=script&lang=js&"
import style0 from "./JournalEditor.vue?vue&type=style&index=0&id=56158353&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56158353",
  null
  
)

export default component.exports